import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { BUSINESS } from "../lib/constants";

export const CTABand = ({
  heading = "Tell us what you need cleaned",
  text = "Every job is different. Send us the details and Kay's Carpet Cleaning will provide an estimate based on your requirements.",
  primaryLabel = "Get My Estimate",
  primaryTo = "/get-estimate",
  id,
}) => (
  <Reveal>
    <div
      id={id}
      data-testid={id ? `${id}-cta-band` : "cta-band"}
      className="relative overflow-hidden bg-brand rounded-tr-[3rem] rounded-bl-[3rem] rounded-tl-2xl rounded-br-2xl px-7 py-12 sm:px-14 sm:py-16 text-center"
    >
      <div aria-hidden="true" className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-white/10 blur-2xl" />
      <h2 className="relative font-display font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white leading-[1.1]">
        {heading}
      </h2>
      <p className="relative mt-4 text-white/80 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">{text}</p>
      <div className="relative mt-8 flex flex-wrap justify-center gap-4">
        <Link
          to={primaryTo}
          data-testid={id ? `${id}-cta-estimate` : "cta-estimate-button"}
          className="group inline-flex items-center gap-2.5 bg-white text-brand-dark font-semibold px-7 py-4 rounded-full text-base transition-transform duration-300 hover:scale-[0.97]"
        >
          {primaryLabel}
          <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
        <a
          href={BUSINESS.phoneHref}
          data-testid={id ? `${id}-cta-call` : "cta-call-button"}
          className="inline-flex items-center gap-2.5 border border-white/50 text-white font-semibold px-7 py-4 rounded-full text-base transition-[background-color] duration-300 hover:bg-white/10"
        >
          <Phone size={18} />
          Call {BUSINESS.phoneDisplay}
        </a>
      </div>
    </div>
  </Reveal>
);
